module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"catchphrase":"Voyagez avec Amplitudes","years":"Moins d\u0027un an | {count} an | {count} ans","ferryText":"Demander un devis Ferry","flightText":"Réserver un vol"},"en":{"catchphrase":"Travel with Amplitudes","years":"Less than a year old | {count} year old | {count} years old","ferryText":"Request a Ferry quote","flightText":"Book a flight"}}')
  delete Component.options._Ctor
}
